module.exports = __webpack_public_path__ + "media/images/proof_links/playgoogle-a3dc3202e47c34aaad63084ea7e96491.svg";